import { Fragment, createContext, useState, useEffect, useContext } from "react";
import ErrorPage from "../pages/common/ErrorPage";
import LoadingPage from "../pages/common/LoadingPage";
import { checkApi } from "../Authentication/AxiosInstance";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

export const SeatMasterContext = createContext();
export const CutoffMasterContext = createContext();
export const useSeatData = () => {
  const context = useContext(SeatMasterContext);
    if (context === undefined) {throw new Error('useSeatData must be used within a DataProvider');}
    return context;
};
export const SeatMasterProvider = ({ children }) => {
  const [seatMasterData, setSeatMasterData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [eMessage, setEMessage] = useState(null);

  useEffect(() => {
    // Fetch data for each array and merge them into one single array
    checkApi
      .get(`${API_ENDPOINT}/capzone/boardseats/`)
      .then((res) => {
        setIsLoading(true);
        setSeatMasterData(res.data);
        setIsLoading(false);
      })
      .catch((error) => {
        //console.log(error)
        setIsLoading(false);
        setEMessage(error.message);
      });
  }, []);
  
  //console.log(seatMasterData);

  return (
    <Fragment>
        {isLoading && <LoadingPage/>}
        {eMessage && <ErrorPage props={eMessage}/>}
        {seatMasterData && 
            <SeatMasterContext.Provider 
              value={{ seatMasterData, setSeatMasterData }}>
                {children}
            </SeatMasterContext.Provider>}
      </Fragment>
  );
}

export const useCutoffData = () => {
  const context = useContext(CutoffMasterContext);
  if (context === undefined) {throw new Error("useCutoffData must be used within a DataProvider");}
  return context;
};

export const CutoffMasterProvider = ({ children }) => {
  const [cutoffMasterData, setCutoffMasterData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [eMessage, setEMessage] = useState(null);

  useEffect(() => {
    // Fetch data for each array and merge them into one single array
    checkApi
      .get(`${API_ENDPOINT}/capzone/boardcutoffs/`)
      .then((res) => {
        setIsLoading(true);
        setCutoffMasterData(res.data);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
        setEMessage(error.message);
      });
  }, []);
  console.log(cutoffMasterData);
  return (
    <div>
      {isLoading && <LoadingPage/>}
      {eMessage && <ErrorPage props={eMessage}/>}
      {cutoffMasterData && 
            <CutoffMasterContext.Provider 
              value={{ cutoffMasterData, setCutoffMasterData }}>
                {children}
            </CutoffMasterContext.Provider>}
    </div>
  );
};











